export default () => `<footer>

<p><a href="https://www.linkedin.com/in/zhanaliner/" target="_blank"><i class="fab fa-linkedin"></i></a> . . . <a href="https://github.com/free4mOriginal" target="_blank"><i class="fab fa-github"></i></a></p>

<p>&copy; 2019 ZK</p>

</footer>`;